import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class TextareaCounter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      length: this.props.value.length,
      value: this.props.value,
    };

    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.value) {
      this.setState({
        value: nextProps.value,
        length: nextProps.value.length,
      });
    }
  }

  onChange(event) {
    const newLength = event.target.value.length;

    // Do not allow change over maxLength
    if (newLength > this.props.maxLength) return;

    const newEvent = {
      target: {
        name: this.props.name,
        value: event.target.value,
        type: 'textarea',
      },
    };

    this.setState({
      length: event.target.value.length,
      value: event.target.value,
    }, () => {
      this.props.onChange(newEvent);
    });
  }

  render() {
    const { onChange, setRef, maxLength, value, ...restProps } = this.props;

    return (
      <div className="textarea-counter">
        <span className={classnames("textarea-counter__count",{'textarea-counter__maxcount': (this.state.length===this.props.maxLength),})}>{this.state.length}/{this.props.maxLength}</span>
        <textarea
          {...restProps}
          ref={setRef}
          value={this.state.value}
          onChange={this.onChange}
        />
      </div>
    );
  }
}

TextareaCounter.defaultProps = {
  onChange: () => {},
  setRef: () => {},
  name: '',
  value: '',
  maxLength: Infinity,
};

TextareaCounter.propTypes = {
  onChange: PropTypes.func,
  setRef: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  maxLength: PropTypes.number,
};
